/// <reference path="../app.ts" />
module Cfnc
{

    export class SubCatAccordion 
    {
        selected: boolean = false;
        kOpen: boolean = false;
        typeCbs: Array<Type>;
        value: string;
        returnFilters: Array<string>;
    }
}